export function criarLoteNovoCompra(novoLote, quantidade) {
  return {
    numero_lote: String(novoLote?.numero_lote || "").trim(),
    data_fabricacao: novoLote?.data_fabricacao || null,
    data_validade: novoLote?.data_validade || null,
    quantidade: Number(quantidade) || 0,
    quantidade_original: 0,
    novo: true,
  };
}

export function atribuirLoteAoItemCompra(item, lote) {
  const quantidade =
    parseFloat(item?.quantidade_conversao ?? item?.quantidade ?? 0) || 0;

  return {
    ...item,
    lote: true,
    lote_baixa: {
      ...lote,
      quantidade,
    },
  };
}

export function indicePrimeiroLotePendente(items = []) {
  return items.findIndex(
    (item) => item?.vinculoProduto?.lote && !item?.lote_baixa
  );
}
